import { buildPaginationQueryParamSchema } from '@guiker/paginate'
import { yup } from '@guiker/yup-util'

import { PayoutMethodStatus } from '../../../entity'

export const readAllPayoutMethodQueryParamsSchema = buildPaginationQueryParamSchema().concat(
  yup.object({
    statuses: yup
      .array()
      .of<PayoutMethodStatus>(yup.mixed<PayoutMethodStatus>())
      .nullable()
      .transform((v) => (!!v ? v : null)),
    searchString: yup.string().nullable(),
  }),
)

export type ReadAllPayoutMethodQueryParamsSchema = yup.InferType<typeof readAllPayoutMethodQueryParamsSchema>
